import { render, staticRenderFns } from "./BlogOverviewPage.vue?vue&type=template&id=d4e94c16"
import script from "./BlogOverviewPage.vue?vue&type=script&lang=js"
export * from "./BlogOverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BreadcrumbNavigation: require('/vercel/path0/components/shared/BreadcrumbNavigation.vue').default,ContainerContent: require('/vercel/path0/components/shared/ContainerContent.vue').default,AllBlogs: require('/vercel/path0/components/shared/AllBlogs.vue').default})
